import { WorkflowFaceVerification } from "../components/workflowFaceVerification/WorkflowFaceVerification";

export function WorkflowFaceVerificationPage() {
  return <WorkflowFaceVerification />;
}
